/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - React Loadable</h2>
    <p className={styles.description}>
      Что произойдет, если запрос на импорт нового компонента займет слишком много времени или HTTP-запрос не удастся.
      Или, возможно, необходимо предварительно загрузить определенные компоненты. Например, пользователь находится
      странице логина, и необходимо предварительно загрузить домашнюю страницу.{' '}
    </p>
    <p className={styles.description}>
      <code className={styles.code}>React Loadable</code> - небольшая библиотека, которая упрощает разделение
      компонентно-ориентированного кода.{' '}
    </p>
    <p className={styles.description}>
      <code className={styles.code}>Loadable</code> - компонент высшего порядка, который позволяет легко разделить код
      на уровне компонентов.
    </p>
    <a
      className={styles.link}
      href="https://github.com/jamiebuilds/react-loadable"
      target="_blank"
      rel="noopener noreferrer"
    >
      Репозиторий react-loadable
    </a>
    <p className={styles.description}>Добавим пакет в проект. </p>
    <CopyBlock text={`npm install react-loadable`} language="javascript" showLineNumbers={false} theme={ocean} />
    <p className={styles.description}>
      Достаточно заменить <code className={styles.code}>asyncComponent</code> на{' '}
      <code className={styles.code}>Loadable</code> и все продолжит работать как и раньше.{' '}
    </p>
    <p className={styles.description}>
      Одно но, можно улучшить компонент <code className={styles.code}>Loading</code>, потому что{' '}
      <code className={styles.code}>react-loadable</code> прокидывает ему несколько очень полезных свойств.
    </p>
    <CopyBlock
      text={`const Loading = ({ error, timedOut, pastDelay, retry }) => {
  if (error) {
    return (
      <div>
        Error! <button onClick={retry}>Retry</button>
      </div>
    );
  }

  if (timedOut) {
    return (
      <div>
        Taking a long time... <button onClick={retry}>Retry</button>
      </div>
    );
  }

  if (pastDelay) {
    return <div>Loading...</div>;
  }

  return null;
};`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
